<app-header [authenticatorHome]="true"></app-header>
<section class="ms-index-page">
  <div class="row home home-img bg-body-secondary gx-0">
    <div class="col-12 col-md-5 col-lg-4 col-xl-3 p-0 h-100">
      <div
        class="h-100 w-100 d-flex justify-content-center align-items-center img-div-md"
      >
        <div class="p-5 pe-0">
          <h1 class="pb-4">Benvenuto nel Portale Operatori di APSS</h1>
          <p class="pb-4">
            All'interno del Portale potrà trovare diverse funzionalità messe a
            disposizione dall'Azienda Provinciale per i Servizi Sanitari di
            Trento.
          </p>
          <app-button colore="primary" (click)="autenticazione(3)"
            >Accedi</app-button
          >
        </div>
      </div>
    </div>
    <div class="d-none d-md-block col-md-7 col-lg-8 col-xl-9 p-0 h-100">
      <div
        class="h-100 img-div d-flex justify-content-center align-items-center"
      ></div>
    </div>
  </div>
</section>
